const cartBt = {
	title: 'ངེད་ཀྱི་ཉོ་སྒྲུབ་གཟུགས་',
	clearAll: 'ཆ་ཚང་བསུབས།',
	itemsInBag: (n) => `${n} ཐེབས་ཚུ་ཁྱེད་ཀྱི་གཟུགས་ནང་ཡོད།`,
	sectionCartItems: 'གཟུགས་ནང་གནས་པའི་ཐེབས་ཚུ',
	continueShopping: 'ཉོ་ཚོང་འཕྲོ་མཐུད།',
	orderSummary: 'གནང་བ་གནས་བསྡུས་',
	subtotal: 'བསྡུས་རྩིས་',
	delivery: 'གཏོང་ལེན་གློག་འཕྲིན་',
	free: 'རིན་མེད་',
	discount: 'མགོན་བསྐྱལ་',
	total: 'བསྡུས་བཅད་',
	couponPlaceholder: 'ཀུ་པཱན་ཨང་བཙུགས།',
	applyCoupon: 'ཀུ་པཱན་ལག་ལེན།',
	proceedCheckout: 'ཞབས་ཞུ་སྤྲོད་ནས་མཇུག་བསྡུས།',
	trust: {
		securePayment: '༡༠༠% མཐའ་བཙན་སྤྲོད་དངུལ་',
		fastDelivery: 'མྱུར་མགྱོགས་གཏོང་ལེན་',
		cod: 'འབྲིང་ལས་དངུལ།'
	},
	empty: {
		title: 'ཁྱེད་ཀྱི་ཀརཊ་སྟོང་པ་རེད།',
		subtitle: 'ད་དུང་ཁྱེད་ཀྱིས་ཐེབས་གཅིག་ཡང་མ་བཙུགས་པས།\nང་ཚོའི་ཐེབས་སྣ་ཚོགས་ལུ་མཐོང་ཞིབ་འབད་ནས་ཉོ་ཚོང་འགོ་འབྱེད།',
		cta: 'ཉོ་ཚོང་འགོ་འབྱེད།'
	},
	item: {
		inStock: 'ཚོང་མི་ནང་ཡོད།',
		removed: 'ཐེབས་ཀྱིས་ཀརཊ་ནང་ལས་བསུབས་ཡོད།'
	},
	cleared: 'ཐེབས་ཆ་ཚང་ཀརཊ་ནང་ལས་བསུབས་ཡོད།'
};

export default cartBt;


